<template>
  <div class="project-info" v-bind:style="{ minHeight: height + 'px' }">
    <div class="container">
      <div class="project-info-wrapper" v-if="currentKit">
        <div class="project-title">{{ currentKitNumber }}</div>
        <div class="main-info-wrapper">
          <div class="info-column">
            <h3 class="main-info-title">Project Details</h3>
            <div class="main-info">
              <status-line
                :isLineShown="true"
                :status="currentKit.status"
                :reason="currentKit.reason_on_hold"
              />
              <h3 class="kitId">
                Kit id: {{ convertKitId(currentKit.kit_id) }}
              </h3>
              <p class="main-info-subtitle">Sampling Date:</p>
              <p class="main-info-description">
                {{ formatDate(currentKit.sampling_date) }}
              </p>
              <div v-if = "sampling_detail">
                <p class="main-info-subtitle">Sampling Location:</p>
                <p class="main-info-description">
                  {{
                    `${currentKit.address}, ${currentKit.city}, ${
                      currentKit.state
                    } ${currentKit.zip}`
                  }}
                </p>
                <p class="main-info-subtitle">Samples Collected By:</p>
                <p class="main-info-description">
                  {{
                    `${currentKit.collected_first_name} ${
                      currentKit.collected_last_name
                    }`
                  }}
                </p>
              </div>
            </div>
            <div v-if="!mobile" style='width:100%'>
              <a target="_blank" v-if="currentKit.report" class="btn-link">
                  <button @click.prevent="getFile" class="download-btn">
                    Download Report
                  </button>
                  <span class="loading-text" v-if="loadingPdf">Loading...</span>
              </a>
           </div>
          </div>
          <div class="info-column" id="btns-complate-wrap">
            <h3 class="main-info-title">Air Sample results</h3>
            <div
              class="main-info"
              v-for="(item, key) in currentKit.indoorSamples"
              :key="key"
            >
              <p class="main-info-subtitle">Indoor Sample #{{ key + 1 }}</p>
              <p class="main-info-description">{{ item.type }}</p>
               <p
                class="main-info-status unable_to_process"
                v-if="
                  currentKit.report &&
                    currentKit.report.reportSamples[key + 1].status === -1
                "
              >
                Unable To Process
              </p>
              <p
                class="main-info-status not_evident"
                v-else-if="
                  currentKit.report &&
                    currentKit.report.reportSamples[key + 1].status === 0
                "
              >
                Not Evident
              </p>
              <p
                class="main-info-status slightly_evident"
                v-else-if="
                  currentKit.report &&
                    currentKit.report.reportSamples[key + 1].status === 1
                "
              >
                Slightly Evident
              </p>
              <p
                class="main-info-status moderately_evident"
                v-else-if="
                  currentKit.report &&
                    currentKit.report.reportSamples[key + 1].status === 2
                "
              >
                Moderately Evident
              </p>
              <p
                class="main-info-status significantly_evident"
                v-else-if="
                  currentKit.report &&
                    currentKit.report.reportSamples[key + 1].status === 3
                "
              >
                Significantly Evident
              </p>
              <p class="main-info-status pending" v-else>Results Pending</p>
            </div>
            <div class="main-info-email form">
              <div class="form">
              <p class="main-info-subtitle text-center">Share Report?</p>
              <p class="main-info-subtitle mt-10 text-center my-10">
                <input
                  type="text"
                  class="input"
                  name="report_name"
                  placeholder="Name"
                  v-model="report_name"
                />
              </p>
              <p class="main-info-subtitle mt-10 text-center my-10">
                <input
                  type="text"
                  class="input toLowerCase"
                  name="report_forward_email"
                  placeholder="Email Address"
                  v-model="report_forward_email"
                />
              </p>
              <p class="main-info-subtitle mt-10 text-center ">
                <textarea 
                  name="report_comment"
                  placeholder="Comment"
                  id="comment"
                  v-model="report_comment"
                ></textarea>
              </p>
              <div class="text-center mt-10 pt-10">
                <button class="btn" @click.prevent="shareReport">
                  <span v-if="currentKit.report">Send</span>
                  <span v-else>Save</span>
                </button>
              </div>
            </div>
           </div>
          </div>
        </div>
        <div v-if="mobile">
          <a target="_blank" v-if="currentKit.report" class="btn-link dwn">
              <button @click.prevent="getFile" class="download-btn">
                Download Report
              </button>
              <span class="loading-text" v-if="loadingPdf">Loading...</span>
            </a>
        </div>
      </div>
      <div class="kit-not-found" v-else-if="notFound">
        <p class="kit-not-found-message">Kit not found.</p>
        <button class="back-to-dashboard-btn" @click="goToDashboard">
          Back to Dashboard
        </button>
      </div>
    </div>
    <ActivateNewKit
      v-if="show"
      :newKitModal="newKitModal"
      @resetModal="resetModal"
      top="120px"
      @changeHeight="changeHeight"
    ></ActivateNewKit>
    <CommonAlertModal
      v-if="alertModal"
      @closeAlertModal="closeAlertModal"
      :message="message"
      :emails="emails"
    ></CommonAlertModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import StatusLine from "./dashboard/StatusLine";
import ActivateNewKit from "./home/ActivateNewKit";
import CommonAlertModal from "./CommonAlertModal";
import { parseAndConvertKitId } from "./mixins/parseAndConvertKitId";

export default {
  name: "ProjectInfo",
  mixins: [parseAndConvertKitId],
  components: {
    StatusLine,
    ActivateNewKit,
    CommonAlertModal
  },
  props: ["newKitModal"],
  data() {
    return {
      currentKit: null,
      notFound: false,
      api_url: process.env.VUE_APP_API_URL,
      files_url: process.env.VUE_APP_FILES_URL,
      currentKitNumber: null,
      loadingPdf: false,
      show: false,
      height: 685,
      mobile:false,
      sampling_detail:true,
      report_forward_email:null,
      report_comment:null,
      report_name:"",
      alertModal: false,
      message: "",
      emails: "",
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  methods: {
    ...mapActions(["profile","userInfo","checkKitIdProfile","savereportemail"]),
    handleResize() {
      if(window.innerWidth < 769){
         this.mobile =true;
      } else {
        this.mobile = false;
      }
    },
    async getFile() {
      // Report download now requires authentication (F-03). Fetch with the
      // logged-in user's token and open the returned PDF as a blob, instead of
      // a plain window.open() which would hit the protected route with no token.
      try {
        const response = await axios({
          url: `${this.files_url}/report/${this.convertKitId(this.currentKit.kit_id)}.pdf`,
          method: "GET",
          responseType: "blob"
        });
        const blobUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        window.open(blobUrl, "_blank");
      } catch (error) {
        console.error("Unable to download report", error);
      }
    },
    async setCurrentKit() {
      const { id } = this.$route.params;
      // Resolve the kit from the authenticated customer's own kits. A missing
      // currentUser, an empty kit list, or an id that matches nothing (invalid,
      // non-existent, or a manually edited URL) all resolve to "not found"
      // rather than throwing or rendering a broken page.
      const testkits =
        (this.currentUser && this.currentUser.testkits) || [];

      testkits.forEach((item, index) => {
        if (item.kit_id == id) {
          this.currentKit = item;
          if(item.indoorSamples && item.indoorSamples.every(item => item.type === null)){
            this.sampling_detail = false;
          }
          this.currentKitNumber = item.title
            ? item.title
            : `Project ${index + 1}`;
        }
      });

      if (!this.currentKit) {
        this.notFound = true;
        return;
      }

      if(this.sampling_detail == false){
        const kitIds = {
          kit_id: this.parseKitId(this.currentKit.kit_id),
          kit_id_confirmation: this.parseKitId(this.currentKit.kit_id)
        };
        this.checkKitIdProfile(kitIds).then(res => {
          this.newKitModal.kit_id = this.currentKit.kit_id;
          this.newKitModal.step = 1; 
          this.show = true;
        });
      }
    },
    formatDate(date) {
      const samplingDate = new Date(date);
      const options = { month: "long", day: "numeric", year: "numeric" };
      return samplingDate.toLocaleDateString("en-US", options);
    },
    resetModal(boolean) {
      this.show = boolean;
    },
    changeHeight(height) {
      this.height = height+136; 
    },
    async shareReport() {
      const data = {
        report_forward_email: this.report_forward_email ? this.report_forward_email : null,
        report_comment: this.report_comment ? this.report_comment : null,
        report_name: this.report_name ? this.report_name : null,
        kit_id: this.currentKit.kit_id,
        status : this.currentKit.status
      };
      await this.savereportemail(data).then(res => {
        if(this.currentKit.report) {
          this.message = "Report Shared";
          this.emails = this.report_forward_email;
        }else{
          this.message = "Email Address Saved";
          this.emails = this.report_forward_email;
        }
        this.alertModal = true;
      });
    },
    closeAlertModal(boolean) {
      this.alertModal = boolean;
    },
    goToDashboard() {
      if (this.$route.path !== "/home") {
        this.$router.push("/home");
      }
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    try {
      if (!this.currentUser) await this.profile();
      await this.setCurrentKit();
    } catch (error) {
      // Any failure loading the profile/kit (e.g. API 404/500) becomes a
      // clean "Kit not found" state instead of a console error or blank page.
      this.currentKit = null;
      this.notFound = true;
    }
    if(this.currentKit !== null) {
      if(this.currentKit.report_forward_email !== null)
      {
        this.report_forward_email = this.currentKit.report_forward_email;
      }
      if(this.currentKit.report_comment !== null)
      {
        this.report_comment = this.currentKit.report_comment;
      }
      if(this.currentKit.report_comment !== null)
      {
        this.report_name = this.currentKit.report_name;
      }
    }
    
  },
  watch: {
    newKitModal() {
      this.show = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/colors";

#comment{
    height: 110px;
    padding: 5px 20px;
    color: $gray;
    width: 70%;
    font-size: 16px;
    outline: none;
    border-radius: 10px;
    border: 1px solid #cccccc;
    font-family: TTNormsMedium, sans-serif;
}
.dwn {
  padding-top: 5px;
}
.project-info {
  background-color: #f4f8f9;
  width: 100%;
  position: relative;
  min-height: calc(100vh - 60px);
}
.btn {
  background-color: $green;
  width: 30%;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 36px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.text-center {
  text-align: center;
}
.mt-10 {
  margin-top: 10px;
}
.container {
  .project-info-wrapper {
    width: 100%;
    min-height: calc(100vh - 60px);
    padding-top: 125px;
    font-family: TTNormsRegular, sans-serif;
    position: relative;
    display: flex;
    flex-direction: column;
    .project-title {
      width: 100%;
      height: 60px;
      background-color: $blue;
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      font-size: 28px;
    }
    .main-info-wrapper {
      display: flex;
      justify-content: space-between;
      .info-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 48%;
        margin-top: 25px;
        .main-info-title {
          text-transform: uppercase;
          color: $blue;
          font-size: 16px;
          font-family: TTNormsMedium, sans-serif;
        }
        .main-info {
          width: 100%;
          padding: 30px 40px;
          display: flex;
          flex-direction: column;
          background-color: $white;
          border-radius: 15px;
          box-shadow: 0 3px 15px -9px $boxShadow;
          color: $gray;
          margin: 20px 0 0 0;
          .kitId {
            color: $blue;
            text-transform: uppercase;
            font-size: 16px;
            font-family: TTNormsMedium, sans-serif;
            margin-bottom: 20px;
          }
          .main-info-subtitle {
            font-family: TTNormsMedium, sans-serif;
            margin-bottom: 5px;
            color: $gray;
          }
          .main-info-description {
            margin-bottom: 16px;
            font-family: TTNormsRegular, sans-serif;
            color: $gray;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .main-info-status {
            margin-top: 4px;
            &.pending {
              font-family: TTNormsMedium, sans-serif;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/no_results.png") center
                  no-repeat;
                background-size: 100px;
              }
            }
            &.unable_to_process {
              font-family: TTNormsMedium, sans-serif;
              color: $gray;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/warning_gauge.svg") center
                  no-repeat;
                background-size: 100px;
              }
            }
            &.not_evident {
              font-family: TTNormsMedium, sans-serif;
              color: $green;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/no-evident.png") center
                  no-repeat;
                background-size: 100px;
              }
            }
            &.slightly_evident {
              font-family: TTNormsMedium, sans-serif;
              color: $yellow;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/slightly_evident.png")
                  center no-repeat;
                background-size: 100px;
              }
            }
            &.moderately_evident {
              font-family: TTNormsMedium, sans-serif;
              color: orange;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/moderate_evident.png")
                  center no-repeat;
                background-size: 100px;
              }
            }
            &.significantly_evident {
              font-family: TTNormsMedium, sans-serif;
              color: $red;
              position: relative;
              &:after {
                content: "";
                display: block;
                position: absolute;
                width: 100px;
                height: 60px;
                top: -55px;
                right: 0;
                background: url("../images/dashboard/significantly_evident.png")
                  center no-repeat;
                background-size: 100px;
              }
            }
          }
        }
      }
    }
    .btn-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      align-self: flex-end;
      .download-btn {
        width: 180px;
        height: 45px;
        border-radius: 25px;
        background-color: $blue;
        color: $white;
        border: none;
        outline: none;
        font-family: TTNormsMedium, sans-serif;
        font-size: 16px;
        cursor: pointer;
        margin: 20px 0 5px 0;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .container {
    .project-info-wrapper {
      padding-top: 90px;
      .main-info-wrapper {
        flex-direction: column;
        .info-column {
          width: 100%;
          .main-info {
            padding: 20px;
          }
        }
      }
      .btn-link {
        align-self: center;
      }
    }
  }
}
.input {
  padding: 5px 20px;
  color: $gray;
  width: 70%;
  font-size: 16px;
  text-align: center;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsMedium, sans-serif;
}
.main-info-email {
  width: 100%;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  background-color: $white;
  border-radius: 15px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  color: $gray;
  margin: 20px 0 0 0;
  .main-info-subtitle {
    font-family: TTNormsMedium, sans-serif;
    margin-bottom: 5px;
    color: $gray;
  }      
} 
.text-center {
  text-align: center;
}
.my-10 {
  padding: 15px 0px;
}
.pt-10 {
  padding-bottom: 10px;
}         
.kit-not-found {
  width: 100%;
  min-height: calc(100vh - 60px);
  padding-top: 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: TTNormsRegular, sans-serif;
  .kit-not-found-message {
    color: $blue;
    font-size: 24px;
    font-family: TTNormsMedium, sans-serif;
    margin-bottom: 24px;
    text-align: center;
  }
  .back-to-dashboard-btn {
    width: 200px;
    height: 45px;
    border-radius: 25px;
    background-color: $blue;
    color: $white;
    border: none;
    outline: none;
    font-family: TTNormsMedium, sans-serif;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.5s linear;
  }
}
@media screen and (max-width: 768px) {
  .kit-not-found {
    padding-top: 90px;
  }
}
</style>
